module.exports = __webpack_public_path__ + "img/thumb_27.7e8f0a99.jpg";